export default "__VITE_ASSET__DN$QwJT5__"